webpackJsonp([19],{

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./src/components/messenger/index.js + 17 modules
var messenger = __webpack_require__(362);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Messenger.vue



/* harmony default export */ var Messenger = ({
  components: {
    MessengerConversations: messenger["b" /* MessengerConversations */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de47638a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Messenger.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:_vm.$route.name,attrs:{"height":"100%"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"conversation",attrs:{"fill-height":"","xs12":"","md3":""}},[_c('messenger-conversations')],1),_vm._v(" "),_c('v-flex',{staticClass:"messages",attrs:{"fill-height":"","xs12":"","md9":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var pages_Messenger = (esExports);
// CONCATENATED MODULE: ./src/pages/Messenger.vue
function injectStyle (ssrContext) {
  __webpack_require__(978)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de47638a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Messenger,
  pages_Messenger,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_pages_Messenger = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(979);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(747)("ce705102", content, true);

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(746)(true);
// imports


// module
exports.push([module.i, ".layout[data-v-de47638a]{height:100%}@media only screen and (max-width:1023px){.Messenger .messages[data-v-de47638a],.MessengerMessage .conversation[data-v-de47638a]{display:none}}@media only screen and (min-width:1024px){.conversation[data-v-de47638a]{padding-right:0}.messages[data-v-de47638a]{padding-left:0}}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Messenger.vue"],"names":[],"mappings":"AACA,yBACE,WAAa,CACd,AACD,0CAIA,uFACI,YAAc,CACjB,CACA,AACD,0CACA,+BACI,eAAiB,CACpB,AACD,2BACI,cAAgB,CACnB,CACA","file":"Messenger.vue","sourcesContent":["\n.layout[data-v-de47638a] {\n  height: 100%;\n}\n@media only screen and (max-width: 1023px) {\n.Messenger .messages[data-v-de47638a] {\n    display: none;\n}\n.MessengerMessage .conversation[data-v-de47638a] {\n    display: none;\n}\n}\n@media only screen and (min-width: 1024px) {\n.conversation[data-v-de47638a] {\n    padding-right: 0;\n}\n.messages[data-v-de47638a] {\n    padding-left: 0;\n}\n}"],"sourceRoot":""}]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/19.0a1a8218cd07ac766163.js